<template>
  <div>
    <div style="float: right" class="text-xs-right">
      <v-btn icon @click="$emit('close')"> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="pa-5 pt-1">
      <v-layout row wrap>
        <v-flex xs12 sm5>
          <div
            style="position: relative; border: 1px solid grey; border-radius: 4px"
            class="showcarouselall"
          >
            <carousel
              :mouseDrag="false"
              :touchDrag="false"
              :pullDrag="false"
              v-if="ref_no_image.length"
              :items="1"
              :loop="true"
              :nav="false"
            >
              <div v-for="(item, k) in ref_no_image" :key="k" style="height: 360px; display: flex">
                <v-img @click="showImage(item, ref_no_image, k)" contain :src="item"></v-img>
              </div>

              <template slot="prev"
                ><v-btn
                  v-show="ref_no_image.length > 1"
                  style="
                    z-index: 2;
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    transform: translate(0%, -50%);
                  "
                  icon
                  small
                  color="primary"
                  ><em class="fas fa-chevron-left" /></v-btn
              ></template>
              <template slot="next"
                ><v-btn
                  v-show="ref_no_image.length > 1"
                  style="
                    z-index: 2;
                    position: absolute;
                    right: 0px;
                    top: 50%;
                    transform: translate(0%, -50%);
                  "
                  icon
                  small
                  color="primary"
                  ><em class="fas fa-chevron-right" /></v-btn
              ></template>
            </carousel>
          </div>
        </v-flex>
        <v-flex xs12 sm7>
          <div class="pa-2 pl-3">
            <div>
              <span style="color: grey">ชื่อลูกค้า : </span> {{ editdata.customer_name }}
              <div
                class="mt-2 form-control"
                style="display: flex"
                :class="{ 'has-error': errors.has('ห้าง') }"
              >
                <div style="align-self: center" class="mr-4 pb-2">ห้าง:</div>
                <div v-if="readonly">{{ input.department_store || '-' }}</div>
                <div v-else style="width: 70%">
                  <multiselect
                    :data-vv-as="$t('ห้าง')"
                    v-validate="'required'"
                    name="ห้าง"
                    @input="input.branch = ''"
                    :options="departmentOptions"
                    v-model="input.department_store"
                  ></multiselect>
                </div>
              </div>
              <div :class="{ 'has-error form-control': errors.has('ห้าง') }">
                <span class="text-error" v-if="errors.has('ห้าง')">{{ errors.first('ห้าง') }}</span>
              </div>
              <div class="mt-2" :class="{ 'has-error': errors.has('สาขา') }" style="display: flex">
                <div style="align-self: center" class="mr-4 pb-2">สาขา:</div>
                <div v-if="readonly">{{ input.branch || '-' }}</div>
                <div v-else style="width: 70%">
                  <multiselect
                    :class="{ 'has-error': errors.has('สาขา') }"
                    :data-vv-as="$t('สาขา')"
                    v-validate="'required'"
                    name="สาขา"
                    :placeholder="
                      !input.department_store ? 'กรุณาเลือกห้างก่อนเลือกสาขา' : 'เลือกสาขา'
                    "
                    :disabled="!input.department_store"
                    :options="branchOptions"
                    v-model="input.branch"
                  >
                  </multiselect>
                </div>
              </div>
              <div :class="{ 'has-error form-control': errors.has('สาขา') }">
                <span class="text-error" v-if="errors.has('สาขา')">{{ errors.first('สาขา') }}</span>
              </div>
            </div>
          </div>
          <div>
            <v-divider class="my-3"></v-divider>
          </div>
          <div class="pl-3">
            <v-layout row wrap>
              <v-flex xs3> <div class="pt-3">เลขที่ใบเสร็จ :</div></v-flex>
              <v-flex xs9>
                <div class="pt-3" v-if="readonly">{{ input.ref_no || '-' }}</div>
                <div
                  v-else
                  class="form-control pa-1"
                  style="position: relative"
                  :class="{ 'has-error': errors.has('เลขที่ใบเสร็จ'), 'is-valid': isRefnoValid }"
                >
                  <input
                    @input="isRefnoValid = false"
                    placeholder="กรอกเลขที่ใบเสร็จ"
                    :data-vv-as="$t('เลขที่ใบเสร็จ')"
                    v-validate="
                      `required${approvetype === 'reject' ? '' : '|excludednew:' + excludedrefno}`
                    "
                    name="เลขที่ใบเสร็จ"
                    v-model="input.ref_no"
                    class="form-control mb-0"
                    type="text"
                  />
                  <span class="text-error" v-if="errors.has('เลขที่ใบเสร็จ')">{{
                    errors.first('เลขที่ใบเสร็จ')
                  }}</span>
                  <div class="text-xs-right">
                    <v-btn
                      @click="checkAvailableRef"
                      :loading="checkRefLoading"
                      color="primary"
                      :disabled="!checkAvailableRefButton"
                      >ตรวจสอบ</v-btn
                    >
                  </div>
                </div>
              </v-flex>

              <v-flex xs3 class="pt-3">Ref. :</v-flex>
              <v-flex xs9>
                <div class="pt-3" v-if="readonly">{{ input.ref || '-' }}</div>
                <div v-else class="form-control pa-1" :class="{ 'has-error': errors.has('Ref') }">
                  <input
                    placeholder="กรอก Ref"
                    :data-vv-as="$t('Ref')"
                    name="Ref"
                    v-model="input.ref"
                    class="form-control"
                    type="text"
                  />
                  <span class="text-error" v-if="errors.has('Ref')">{{ errors.first('Ref') }}</span>
                </div>
              </v-flex>
              <v-flex xs3 class="pt-3">วันที่ในเอกสาร :</v-flex>
              <v-flex xs9>
                <div class="pt-3" v-if="readonly">{{ input.date | DateFormat('DD/MM/YYYY') }}</div>
                <div
                  v-else
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('วันที่ในเอกสาร') }"
                >
                  <DatePickerWithoutButton @input="errors.clear()" v-model="input.date">
                    <input
                      readonly
                      placeholder="กรอกวันที่ในเอกสาร"
                      :data-vv-as="$t('วันที่ในเอกสาร')"
                      v-validate="'required'"
                      name="วันที่ในเอกสาร"
                      :value="getDate(input.date)"
                      class="form-control"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                  <span class="text-error" v-if="errors.has('วันที่ในเอกสาร')">{{
                    errors.first('วันที่ในเอกสาร')
                  }}</span>
                </div></v-flex
              >
            </v-layout>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>
      <div>
        <div class="my-3">
          <div style="font-weight: 600; font-size: 19px">
            {{ readonly ? '' : 'กรอก' }}ข้อมูลสินค้า
          </div>
        </div>
        <div>
          <v-layout row wrap>
            <v-flex xs2>
              <div class="text-center">เลือกสินค้า (SKU)</div>
            </v-flex>
            <v-flex xs3>
              <div class="text-center">ชื่อสินค้า</div>
            </v-flex>

            <v-flex xs2> <div class="text-center">ราคา</div></v-flex>
            <v-flex xs2> <div class="text-center">จำนวน</div></v-flex>
            <v-flex xs2> <div class="text-center">รวมเงิน</div></v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs12 class="pa-0 ma-0 pt-1">
              <div class="pa-2">
                <div v-for="(item, k) in products" :key="k">
                  <v-layout class="ma-0 pa-0">
                    <v-flex style="align-self: center" xs2>
                      <div v-if="readonly">
                        {{ item.name.product_name }}
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('สินค้า' + k) }"
                      >
                        <multiselect
                          :ref="'skuinput' + k"
                          @input="onChangeProduct(k, $event)"
                          :custom-label="customProductsName"
                          v-model="item.name"
                          placeholder="สินค้า"
                          :show-labels="false"
                          label="sku"
                          :options="allproducts"
                          :name="'สินค้า' + k"
                          :data-vv-as="$t('สินค้า')"
                        ></multiselect>
                        <span class="text-error" v-if="errors.has('สินค้า' + k)">{{
                          errors.first('สินค้า' + k)
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex tabindex="-1" style="align-self: center" class="text-xs-center" xs3>{{
                      item.name.product_name
                    }}</v-flex>
                    <v-flex style="align-self: center" xs2 class="form-control">
                      <div class="text-xs-center" v-if="readonly">
                        {{ numberFormat(item.price) }}
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('ราคา' + k) }"
                      >
                        <input
                          @blur="!item.price ? (item.price = 0) : ''"
                          @keyup.enter="addmoreproduct"
                          placeholder="ราคา"
                          :data-vv-as="$t('ราคา')"
                          v-validate="'required'"
                          :name="'ราคา' + k"
                          min="0"
                          v-model="item.price"
                          class="form-control"
                          type="number"
                        />
                        <span class="text-error" v-if="errors.has('ราคา' + k)">
                          {{ errors.first('ราคา' + k) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex style="align-self: center" xs2 class="form-control">
                      <div class="text-xs-center" v-if="readonly">
                        {{ numberFormat(item.quantity) }}
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('จำนวน' + k) }"
                      >
                        <input
                          @blur="!item.quantity || item.quantity == 0 ? (item.quantity = 1) : ''"
                          @keyup.enter="addmoreproduct"
                          placeholder="จำนวน"
                          :data-vv-as="$t('จำนวน')"
                          v-validate="'required'"
                          :name="'จำนวน' + k"
                          v-model="item.quantity"
                          class="form-control"
                          type="number"
                        />
                        <span class="text-error" v-if="errors.has('จำนวน' + k)">
                          {{ errors.first('จำนวน' + k) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex xs2 style="align-self: center">
                      <div style="font-size: 17px" class="text-xs-center">
                        <span>
                          {{ numberFormat(item.quantity * item.price) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex style="align-self: center" v-if="!readonly" xs1 class="text-xs-right">
                      <v-btn
                        tabindex="-1"
                        @click="deleteProducts(k)"
                        icon
                        v-if="editdata.accounting_status !== 'approved'"
                        ><v-icon color="primary">delete</v-icon></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </div>
                <v-divider class="my-2"></v-divider>
              </div>
              <div v-if="!readonly" class="text-xs-right">
                <v-btn
                  @click="addmoreproduct"
                  flat
                  color="primary"
                  v-if="editdata.accounting_status !== 'approved'"
                  ><em class="mr-2 fas fa-plus" /> เพิ่มสินค้า</v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="px-3">
        <v-layout row wrap>
          <v-flex xs7>
            <v-layout row wrap>
              <v-flex xs5 class="mt-1">คะแนนจากยอดซื้อ </v-flex>
              <v-flex xs7
                ><span class="mr-2" style="font-weight: 600; font-size: 19px">{{
                  numberFormat(points_by_purchase)
                }}</span>
                คะแนน
              </v-flex>
              <v-flex xs5 class="mt-1">คะแนนจากรายการสินค้า </v-flex>
              <v-flex xs7
                ><span class="mr-2" style="font-weight: 600; font-size: 19px">{{
                  numberFormat(points_by_product)
                }}</span>
                คะแนน
              </v-flex>
              <v-flex xs5 class="mt-1">รวม </v-flex>
              <v-flex xs7
                ><span class="mr-2" style="font-weight: 600; font-size: 19px"
                  >{{ numberFormat(points_by_purchase + points_by_product) }} </span
                >คะแนน
              </v-flex>
            </v-layout></v-flex
          >
          <v-flex xs5>
            <div style="font-size: 17px">
              รายการสินค้า
              <span class="primary--text text--weight-bold" style="font-weight: bold">{{
                products.length
              }}</span>
              รายการ

              <br />
              จำนวนทั้งหมด

              <span class="primary--text text--weight-bold" style="font-weight: bold"
                >{{ numberFormat(sumquantity) }}
              </span>
              รายการ
              <br />

              ยอดซื้อรวม
              <span class="primary--text font-weight-bold">{{ numberFormat(sumprice) }}</span> บาท
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div class="text-xs-center" v-if="editdata.accounting_status !== 'approved'">
        <div
          class="form-control text-xs-center"
          :class="{ 'has-error': errors.has('Approve / Reject') }"
        >
          <v-radio-group
            :error-messages="!approvetype ? errors.first('Approve / Reject') : ''"
            class="mb-0 pb-0"
            :name="'Approve / Reject'"
            v-validate="'required'"
            :data-vv-as="$t('Approve / Reject')"
            style="justify-content: center !important"
            row
            v-model="approvetype"
          >
            <v-radio color="green" value="approved">
              <template v-slot:label> <span class="green--text">Approve</span> </template>
            </v-radio>
            <v-radio color="red" value="reject">
              <template v-slot:label> <span class="red--text">Reject</span> </template></v-radio
            >
          </v-radio-group>
          <!-- <div>
            <span class="text-error" v-if="errors.has('Approve / Reject')">
              {{ errors.first('Approve / Reject') }}
            </span>
          </div> -->
        </div>
      </div>
      <div v-if="approvetype == 'reject'">
        <div class="form-control text-xs-center" :class="{ 'has-error': errors.has('remark') }">
          <input
            style="width: 50%"
            placeholder="กรอกสาเหตุที่ Reject"
            :data-vv-as="$t('สาเหตุที่ Reject')"
            v-validate="'required'"
            :name="'remark'"
            v-model="input.remark"
            class="form-control"
            type="text"
          />
          <span class="text-error" v-if="errors.has('remark')">
            {{ errors.first('remark') }}
          </span>
        </div>
      </div>
      <div class="text-xs-center mt-2" v-if="editdata.accounting_status !== 'approved'">
        <v-btn @click="saveData" :loading="saveloading" depressed color="primary">ยืนยัน</v-btn>
        <v-btn @click="$emit('close')" color="grey" outline>ยกเลิก</v-btn>
      </div>
    </div>
    <v-dialog v-model="showImageDialog" width="550px" persistent>
      <v-card v-if="showImageDialog">
        <div class="text-xs-right">
          <v-btn @click="showImageDialog = false" icon> <v-icon>close</v-icon></v-btn>
        </div>
        <img style="object-fit: contain; width: 100%" :src="currentShowImage" />
        <div class="pa-3"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import Multiselect from 'vue-multiselect'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import CurrencyInput from '@/components/elements/CurrencyInput.vue'
import PhotoViewer from 'photoviewer'
export default {
  components: {
    carousel,
    Multiselect,
    DatePickerWithoutButton,
    CurrencyInput
  },
  props: ['editdata', 'readonly', 'alldata'],
  data() {
    return {
      checkRefLoading: false,
      isRefnoValid: false,
      excludedrefno: '',
      excludedsku: '',
      currentShowImage: '',
      showImageDialog: false,
      ref_no_image: [],
      saveloading: false,
      approvetype: '',
      input: {
        branch: '',
        department_store: '',
        ref_no: '',
        ref: '',
        date: '',
        remark: ''
      },
      products: [
        {
          name: '',
          price: 0,
          quantity: 0,
          total: 0
        }
      ]
    }
  },
  computed: {
    checkAvailableRefButton() {
      return this.input.branch && this.input.department_store && this.input.ref_no
    },
    ...mapGetters(['selectedBot']),
    sumquantity() {
      return Math.floor(
        this.products.reduce((acc, cur) => {
          return acc + parseFloat(cur.quantity || 0)
        }, 0)
      )
    },
    sumprice() {
      return Math.floor(
        parseFloat(
          this.products.reduce((acc, cur) => {
            return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity)
          }, 0)
        )
      )
    },
    points_by_purchase() {
      var result = 0
      var sum = this.products.reduce((acc, cur) => {
        return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity || 0)
      }, 0)
      result = sum / this.purchase_amount
      return Math.floor(result)
    },
    points_by_product() {
      var result
      result = this.products.reduce((acc, cur) => {
        return (
          acc + (cur.name ? parseFloat(cur.name.points || 0) : 0) * parseFloat(cur.quantity || 0)
        )
      }, 0)
      return Math.floor(result)
    },
    purchase_amount() {
      if (this.$store.state.toacrmpointdata && this.$store.state.toacrmpointdata.purchase_amount) {
        return Math.floor(parseFloat(this.$store.state.toacrmpointdata.purchase_amount))
      } else return 0
    },
    allproducts() {
      var localsku = this.products.map((el) => {
        return el.name.sku
      })

      var result = this.$store.state.toacrmproducts.filter((el) => {
        if (!this.input.department_store) {
          return true
        } else {
          return el.department_store == this.input.department_store
        }
      })

      result = result.map((el) => {
        return {
          ...el,
          $isDisabled: [...localsku, ...this.excludedsku].includes(el.sku)
        }
      })
      return result
    },
    departmentOptions() {
      var departments = [
        ...new Set(this.$store.state.toacrmbranch.map((el) => el.department_store))
      ]

      return departments
    },
    branchOptions() {
      if (this.input.department_store) {
        var departments = this.$store.state.toacrmbranch
          .filter((el) => el.department_store == this.input.department_store)
          .map((el) => el.branch)
        return departments
      } else return []
    }
  },
  mounted() {
    window.scrollTo(0, 0)

    try {
      const attachments = JSON.parse(this.editdata.ref_no_image)
      this.ref_no_image = attachments ? attachments.filter((attachment) => attachment) : []
    } catch (error) {
      console.error(error)
      this.ref_no_image = []
    }
    this.input.department_store = this.editdata.department_store
    this.input.branch = this.editdata.branch
    this.input.ref_no = this.editdata.ref_no
    this.input.date = moment(this.editdata.timestamp).format('YYYY-MM-DD')
    this.input.ref = this.editdata.details.ref
    if (this.editdata.details) {
      this.products = this.editdata.details.products
      if (this.editdata.details.date) {
        this.input.date = this.editdata.details.date
      }
    }
    var allotherdata = this.alldata.filter((el) => {
      return (
        el.id !== this.editdata.id &&
        el.department_store === this.editdata.department_store &&
        el.branch === this.editdata.branch
      )
    })
    this.excludedrefno = allotherdata.map((el) => el.ref_no).join(',')
    this.excludedsku = allotherdata.map((el) => el.details.products.map((val) => val.name.sku))
    this.excludedsku = [].concat.apply([], this.excludedsku)
  },
  methods: {
    showImage(item, images, k) {
      var items = images.map((el, index) => {
        return {
          src: el,
          title: `${index + 1}/${images.length}`
        }
      })

      // define options (if needed)
      var options = {
        fixedContent: false,
        fixedModalPos: true,
        index: k // this option means you will start at first image
      }

      // Initialize the plugin
      var viewer = new PhotoViewer(items, options)
      document.querySelector('.photoviewer-modal').addEventListener(
        'click',
        function (event) {
          //  document.getElementById("output-box").innerHTML += "Sorry! <code>preventDefault()</code> won't let you check this!<br>";
          event.preventDefault()
        },
        false
      )
    },
    checkAvailableRef() {
      var data = {
        pageid: this.selectedBot.pageid,
        id: this.editdata.id, // id ของรายการ
        refNo: this.input.ref_no, // เลขที่ใบเสร็จ
        departmentStore: this.input.department_store, // ห้าง
        branch: this.input.branch // สาขา
      }
      this.checkRefLoading = true
      api.getToacrmCheckAvailableRef(data, async (err, response) => {
        this.checkRefLoading = false
        if (response.responsecode == 200) {
          this.isRefnoValid = true
        } else {
          await this.$swal.fire({
            text: 'เลขที่ใบเสร็จนี้ ถูกใช้แล้ว'
          })
          this.isRefnoValid = false
        }
      })
    },
    async saveData() {
      if (await this.$validator.validateAll()) {
        this.saveloading = true
        if (['admin', 'superadmin'].includes(this.$store.state.privilege.role)) {
          await this.adminSave()
        } else if (['manager'].includes(this.$store.state.privilege.role)) {
          await this.managerSave()
        } else if (['accounting'].includes(this.$store.state.privilege.role)) {
          await this.accountingSave()
        }

        this.saveloading = false
      }
    },
    adminSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          id: this.editdata.id, // id ของรายการสะสมแต้ม
          status: this.approvetype, // approved หรือ reject
          details: {
            ref_no: this.input.ref_no,
            ref: this.input.ref,
            date: this.input.date,
            products: this.products
          }, // ไม่ต้อง stringify
          department_store: this.input.department_store,
          branch: this.input.branch,
          points_by_purchase: this.points_by_purchase, // points รวมที่ได้จากยอดซื้อทั้งหมด
          points_by_product: this.points_by_product, // points รวมที่ได้จากรายการสินค้าทั้งหมด
          total_points: this.points_by_purchase + this.points_by_product, // คะแนนรวม points ทั้งหมด
          ...(this.approvetype == 'reject' ? { remark: this.input.remark } : {}) // ส่งมาเฉพาะถ้า status > reject
        }

        api.Adminapprovereceipttoacrm(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            this.$emit('onsave')
          }
          resolve()
        })
      })
    },
    managerSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: [this.editdata.id],
          manager_status: this.approvetype, // approved หรือ reject

          ...(this.approvetype == 'reject' ? { remark: this.input.remark } : {}) // ส่งมาเฉพาะถ้า status > reject
        }

        api.Managerapprovereceipttoacrm(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            this.$emit('onsave')
          }
          resolve()
        })
      })
    },
    accountingSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: [this.editdata.id],
          accounting_status: this.approvetype, // approved หรือ reject

          ...(this.approvetype == 'reject' ? { remark: this.input.remark } : {}) // ส่งมาเฉพาะถ้า status > reject
        }

        api.Accountingapprovereceipttoacrm(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            this.$emit('onsave')
          }
          resolve()
        })
      })
    },
    customProductsName(val) {
      return val.sku
    },
    deleteProducts(k) {
      this.products.splice(k, 1)
      this.errors.clear()
    },
    addmoreproduct() {
      this.products.push({
        name: '',
        price: 0,
        quantity: 1,
        total: 0
      })
      this.$nextTick(() => {
        const skuref = this.$refs['skuinput' + (this.products.length - 1)]
        skuref[0].$el.focus()
      })
    },
    onChangeProduct(k, e) {
      this.products[k].price = e.price
    },
    getDate(val) {
      if (val) return moment(val).format('DD/MM/YYYY')
      else return ''
    }
  }
}
</script>

<style lang="scss">
.showcarouselall div span {
  /* Your style */
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/ApproveReceiptEdit.vue